import React, { useContext, useEffect, useState } from 'react'
import { activeList, inactiveList } from './ActiveInactiveList'
import { glmisccount } from '../../../../services/dwhservices';
import { decryptPII } from '../../../../utils/encryption/aesEncryption';
import ListDiv from './ListDiv';
import { Alert } from '../../../../utils/Alert';
import NachPopup from './NachPopup';
import { ctcActivity, insertclicktocall, nachDetails, nachStop } from '../../../../services/merpservices';
import EmployeeContext from '../../../../utils/EmpDetails/EmployeeProvider';
import { gaEvent } from '../../../../utils/GoogleAnalytics/gatracking';
import {maskMobileNumber} from '../../../../utils/Misc/maskMobileNumber'
import { buildAPIRequestParams } from '../../../../utils/Misc/buildAPIParams';
import { handleCreateTicket } from '../handleCreateTicket';
import { handleTicketClosure } from '../handleTicketClosure';


const NachStop = ({ glid, stsComments, stsID, OcrTicket, updateSTS, descId, getNACHData }) => {
    const employeeDetails = useContext(EmployeeContext)

    const [dauData, setDauData] = useState([]);
    const [checkedValues, setCheckedValues] = useState([]);
    const [nachRadioBtnSelect, setNachRadioBtnSelect] = useState("");
    const [isNachPopShow, setIsNachPopUpShow] = useState(false);
    const [nachStopWarningMsg, setnachStopWarningMsg] = useState(false);
    const [noECSDebit, setNoECSDebit] = useState(-1);
    const [disableYesBtn , setDisableYesBtn] = useState(false);

    let createTicketParams = buildAPIRequestParams({
      empid: employeeDetails?.empid,
      AK: employeeDetails?.ak,
      glid: glid,
      modid: 9696,
      typeid: 199,
      groupid: 15,
      flag: "ocr",
      source_id: 3,
    });

    const activeInactiveList = async () => {
        try {
            const res = await glmisccount(glid);
            if (res?.data?.status_code === 200) {
                let data = res?.data?.response;
                data = JSON.parse(data)
                setDauData(data?.bl_dau);
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        activeInactiveList();
    }, [])

    const handleNachStop = () => {
        if (descId === '') {
            Alert("Please submit call disposition first.");
        } else {
            if (checkedValues.length >= 1) {
                if (nachRadioBtnSelect === '') {
                    setnachStopWarningMsg(true)
                    alert('Please select one of the nach dispostions to proceed.')
                    return
                }
                if (nachRadioBtnSelect === "1516") {
                    if (noECSDebit === -1) {
                        alert("Please Select Number Of ECS Debits.")
                        return
                    }
                }
                setnachStopWarningMsg(false)
                setIsNachPopUpShow(true);
                gaEvent("NACH Stop", "Stop NACH CTA", "click", "Stop NACH CTA Button", glid);
            } else {
                Alert("Please select at least one of the discussion points.");
            }
        }
    }


    const handleNachStopYesBtn = async () => {
        setDisableYesBtn(true)
        // Search URL Params
        const urlParams = new URLSearchParams(window.location.search);
        const ONum = decryptPII(urlParams.get('origNum') || "");
        const phone = decryptPII(urlParams.get('phone') || "");
        const ucid = urlParams.get('crtObjectId') || "";
        let nach_type = 1; // 1 for nach stop immediate and 0 for nach end date marked
        let ecs_number = noECSDebit;
        if (nach_type === 1) {
            ecs_number = 0
        }
        if (nachRadioBtnSelect === "1516") {
            nach_type = 0; //nach end date marked
        }
        // NACH Details API
        if (getNACHData?.data?.length) {
            const nachOutput = getNACHData?.data;
            let end_date = nachOutput[0]['AR_ECS_DATE'];
            if (end_date.length === 1) {
                end_date = `0${end_date}`
            }
            const proformaid = nachOutput[0]['FK_PROFORMA_ID']; //done
            const ecs_end_date = nachOutput[0]['AR_ECS_END_DATE']; //done
            const last_stopped_reason = nachOutput[0]['ECS_STOPPED_REASON_NAME'] === "" ? 'Deal Canceled' : nachOutput[0]['ECS_STOPPED_REASON_NAME']; //done
            const last_ecs_activity_status = nachOutput[0]['AR_ECS_IS_ACTIVE']; //done
            const ecsid = nachOutput[0]['AR_ECS_ID']; //done
            const nachcode = nachOutput[0]['AR_ECS_CODE'];
            // nach_type
            // ecsnumber
            const new_stopped_reason = 'Deal Canceled';
            const comments = 'Deal Canceled';
            // last comments
            const tickets_clousers_id = nachRadioBtnSelect;
            const tickets_clousers_id1 = nachRadioBtnSelect;
            const tickets_clousers_id2 = nachRadioBtnSelect;
            const tickets_clousers_id3 = nachRadioBtnSelect;
            const new_tickets_clousers_id1 = nachRadioBtnSelect;
            const new_tickets_clousers_id2 = nachRadioBtnSelect;
            const discussion_points = `${stsComments} \n Points Discussed from Checklist - ${checkedValues.toString()} `

            // Calutate Todays Date
            const date = new Date();
            const day = String(date.getDate()).padStart(2, '0');
            const month = date.toLocaleString('default', { month: 'short' }).toUpperCase();
            const year = date.getFullYear();
            const today = `${day}-${month}-${year}`;
            // End Calculate Today's Date
            const mobile_num = ONum || phone;
            const crtObjId = ucid
            let actionTakenName = "";
            let actionTakenId = "";
            let tktComments = '';
            let condition = "";

            if (ecs_end_date === today) {
                Alert("Nach cannot be stopped on nach hit date");
                return;
            } else {
                if (tickets_clousers_id === "1528") {
                    tktComments = `${crtObjId}~~Received a call from ${maskMobileNumber(mobile_num)}.. Service Deactivation NachStop.<br> ${discussion_points} <br> Nach Status - Nach Stopped`;
                    condition = "&comments=disp:nach%20stopped";
                    actionTakenId = tickets_clousers_id;
                    actionTakenName = "NACH Stopped";
                } else if (tickets_clousers_id === "1516") {
                    tktComments = `${crtObjId}~~Received a call from ${maskMobileNumber(mobile_num)}.. Service Deactivation Nach End Date Marked.<br> ${discussion_points} <br> Nach Status- Nach End Date Marked`;
                    condition = "&comments=disp:nach%20end%20date%20marked";
                    actionTakenId = tickets_clousers_id;
                    actionTakenName = "NACH End Date Marked";
                }

                try {
                    await insertclicktocall(employeeDetails?.empid, employeeDetails?.ak, crtObjId, 'u', 1, condition);
                    await ctcActivity(employeeDetails?.empid, employeeDetails?.ak, crtObjId, 4);
                    createTicketParams = {...createTicketParams,comment: tktComments };
                    const createRes = await handleCreateTicket(createTicketParams);
                    if(createRes.success) {
                        const ticketId = createRes.ticketId;
                        const ticketTypeid = createRes.ticketTypeid;
                        const closingTicketParams = {
                            ticketId: ticketId,
                            ticketTypeid: ticketTypeid,
                            employeeDetails: employeeDetails,
                            tktComments: tktComments,
                            tickets_clousers_id: 1096,
                            tickets_clousers_id1: tickets_clousers_id,
                            tickets_clousers_id2: 1505,
                            showAlert: false,
                        };
                        await handleTicketClosure(closingTicketParams);
                        const nachSTOPParams = {
                            glid: glid,
                            empid: employeeDetails?.empid,
                            AK: employeeDetails?.ak,
                            updatedbyid: employeeDetails?.empid,
                            modid: 'weberp',
                            screen_name: '9696',
                            nach_type: nach_type,
                            reason: '3',
                            ecs_number: ecs_number,
                            proformaid: proformaid,
                            ecs_end_date: ecs_end_date,
                            last_stopped_reason: last_stopped_reason,
                            new_stopped_reason: new_stopped_reason,
                            comments: comments,
                            lastcomment: last_stopped_reason,
                            last_ecs_activity_status: last_ecs_activity_status,
                            ecsid: ecsid,
                            nachcode: nachcode,
                            ticket_id: ticketId,
                            tickets_clousers_id: tickets_clousers_id,
                            tickets_clousers_id1: tickets_clousers_id1,
                            tickets_clousers_id2: tickets_clousers_id2,
                            tickets_clousers_id3: tickets_clousers_id3,
                            new_tickets_clousers_id2: new_tickets_clousers_id2,
                            new_tickets_clousers_id1: new_tickets_clousers_id1,
                            escalationNo: '0',
                            active_reason: '1',
                            ...(nach_type !== 1 && { end_date: end_date }) // Add end_date if nach_type is not 1
                        };
                        
                        const nachStopAPIResponse = await nachStop(nachSTOPParams)
                        if (nachStopAPIResponse?.data?.message) {
                            Alert("Nach Stopped Successfully!!");
                            setIsNachPopUpShow(false)
                            return
                        }
                    } else {
                        Alert("Error in STS OCR processing...!");
                        setIsNachPopUpShow(false);
                        return
                    }
                } catch (error) {
                    console.log(error)
                }
            }

        } else {
            Alert("NACH does not exist for the Customer");
            setIsNachPopUpShow(false)
            return
        }
    }

    const url = new URL(document.location.href);
    const crtObjId = url.searchParams.get('crtObjectId');
    const phone = decryptPII(url.searchParams.get('phone'));
    const origNum = decryptPII(url.searchParams.get('origNum'));

    const handleUpateSTS = async() => {
        if(stsComments === ""){
            Alert("Please enter comment here to update STS...");
            return
        }

        let callComments = ""

        if(crtObjId !== null){
            callComments = `${crtObjId}~~Received a call from ${maskMobileNumber(origNum || phone)}...${stsComments}`;
        }

        if(nachRadioBtnSelect === "2378"){
            if(checkedValues.length){
                const condition = "&comments=disp:retained";
                createTicketParams = {
                ...createTicketParams,
                comment: `${callComments} \n Points Discussed from Checklist - ${checkedValues.toString()} \n Nach Status - Retained `
                };
                const createRes  = await handleCreateTicket(createTicketParams);
                if (createRes.success) {
                  const closureParams = {
                    ticketId: createRes.ticketId,
                    ticketTypeid: createRes.ticketTypeid,
                    employeeDetails: employeeDetails,
                    tktComments: `${callComments} \n Points Discussed from Checklist - ${checkedValues.toString()} \n Nach Status - Retained `,
                    tickets_clousers_id: 1096,
                    tickets_clousers_id1: 2378,
                    tickets_clousers_id2: 1505,
                    showAlert: true,
                    crtObjId: crtObjId,
                  };
                  await handleTicketClosure(closureParams);
                }
                try {
                    await insertclicktocall(employeeDetails?.empid, employeeDetails?.ak, crtObjId, 'u', 1, condition);
                } catch (error) {
                    console.log(error) 
                }
                // OcrTicket(params)
            }else{
                Alert("Please select at least one of the discussion points.");
				return 
            }
        }else{
            updateSTS('update STS');
        }
    }

    const nachGATracking = (value) => {
        const eventDetails = {
            "1528": ["NACH Stop", "Nach Stopped Radio Btn", "click", "Nach Stopped Radio Btn"],
            "1516": ["NACH Stop", "Nach End Date Marked Radio Btn", "click", "Nach End Date Marked Radio Btn"],
            "2378": ["NACH Stop", "Nach Retained Radio Btn", "click", "Nach Retained Radio Btn"]
        };
    
        const details = eventDetails[value];
        if (details) {
            gaEvent(...details, glid);
        }
    }

    return (
        <>
            <div className='quick_disp_template1'>
                {
                    dauData.length && dauData[0]?.bl_dau_1m >= 10 ?
                        <ListDiv list={activeList} checkedValues={checkedValues} setCheckedValues={setCheckedValues} /> : <ListDiv list={inactiveList} checkedValues={checkedValues} setCheckedValues={setCheckedValues} />
                }
            </div>
            <div style={{marginTop: '10px'}}>
                <input type="radio" name="option" id="stoppedRadio" value="1528" onClick={(e) => {setNachRadioBtnSelect(e.target.value); nachGATracking(e.target.value)}} /> Nach Stopped 
                <input type="radio" name="option" id="endDateRadio" value="1516" onClick={(e) => {setNachRadioBtnSelect(e.target.value); nachGATracking(e.target.value)}} style={{marginLeft:'20px'}} /> Nach End Date Marked <br /><br />
                <input type="radio" name="option" id="retainedRadio" value="2378" onClick={(e) => {setNachRadioBtnSelect(e.target.value); nachGATracking(e.target.value)}} /> Retained
            </div>

            {nachStopWarningMsg && <p style={{ color: 'red' }}>Please select one of the nach dispostions to proceed</p>}

            {
                nachRadioBtnSelect === "1516" && (
                    <div style={{marginTop: '10px'}}>
                        <label className="f14" for="reasonDropdown">No of ECS debits:</label>
                        <select id="noofdebit" onClick={(e) => setNoECSDebit(e.target.value)}>
                            <option value="-1">unlimited</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                        </select>
                    </div>
                )
            }
            <div className="comment-btn cp">
                <span className="me-2" style={{ backgroundColor: '#f29766' }} onClick={() => { handleNachStop() }}>Stop NACH</span>
                <span className="ms-2" onClick={()=>{handleUpateSTS()}}>Update STS</span>
            </div>
            {
                isNachPopShow && <NachPopup setIsNachPopUpShow={setIsNachPopUpShow} handleNachStopYesBtn={handleNachStopYesBtn} disableYesBtn={disableYesBtn} />
            }
        </>
    )
}

export default NachStop